import styled from 'styled-components';

export const Backend = styled.div`
  height: 100%;
`;
